var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var DoctorScheduleConfig = /** @class */ (function (_super) {
    __extends(DoctorScheduleConfig, _super);
    function DoctorScheduleConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DoctorScheduleConfig.prototype.getMaxAppointments = function () {
        var _a;
        return Number((_a = this.max_appointments) !== null && _a !== void 0 ? _a : 0);
    };
    DoctorScheduleConfig.prototype.setMaxAppointments = function (value) {
        this.max_appointments = Number(value);
    };
    DoctorScheduleConfig.prototype.getMaxOnlineAppointments = function () {
        var _a;
        return Number((_a = this.max_online_appointments) !== null && _a !== void 0 ? _a : 0);
    };
    DoctorScheduleConfig.prototype.setMaxOnlineAppointments = function (value) {
        this.max_online_appointments = Number(value);
    };
    DoctorScheduleConfig.prototype.isOnlineAppointmentEnabled = function () {
        return this.online_appointment_enabled !== false;
    };
    DoctorScheduleConfig.prototype.setOnlineAppointmentEnabled = function (value) {
        this.online_appointment_enabled = value;
    };
    return DoctorScheduleConfig;
}(Model));
export default DoctorScheduleConfig;
